/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
    }).then((data) => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
    }).then((data) => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
    }).then((data) => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`).then((data) =>
        data.json()
    );
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`).then((data) => data.json());
}

/*  OLD PRICE function
// print price (515491 => $5,154.91)
function price(amountInCents, options) {
    // fallback since the option parameter used to be a boolean: removeTrailingZeros
    if (typeof options === "boolean") {
        options.removeTrailingZeros = true;
    }

    // calculate total
    let total = (parseFloat(amountInCents) / 100);

    // round down
    if (options?.roundDown) {
        total = Math.floor(total);
    }

    // convert to fixed & string
    total = total.toFixed(options?.removeDecimals ? 0 : 2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (options?.removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return shopCurrency === "ISK"
        ? `${total} ${currency}`
        : `${currency}${total}`;
}
*/

function price(amountInCents, options = {}) {
  // Back-compat: when options was a boolean meaning "removeTrailingZeros"
  if (typeof options === "boolean") {
    options = { removeTrailingZeros: true };
  }

  let total = Number(amountInCents) / 100;

  if (options.roundDown) total = Math.floor(total);

  // ISK usually has no decimals; allow caller override
  const decimals = options.removeDecimals ? 0 : 2;
  total = total.toFixed(decimals);

  // add thousand separators
  total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // robust trailing-zero removal: "12.50" -> "12.5", "12.00" -> "12"
  if (options.removeTrailingZeros) {
    total = total.replace(/(\.\d*[1-9])0+$|\.0+$/, "$1");
  }

  return shopCurrency === "ISK"
    ? `${total} ${currency}`      // e.g. "16,899 kr."
    : `${currency}${total}`;      // e.g. "$16,899.90"
}

// sleep
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

// Build Repeat url
function buildRepeatUrl(cleanCart = false) {
    return new Promise((resolve, reject) => {
        const repeatShopUUID = "21f7372a-a033-4f62-8fa4-5f5c23a04869";
        let isRepeatCheckout = false;

        getCart()
            .then((cart) => {
                var cartToken = cart.token;
                const cartParam = "&shopify_cart_token=" + cartToken;

                let repeatCheckoutUrl = `https://repeat.is/repeat_checkout/${repeatShopUUID}/?currency=${shopCurrency}&language=is${cartParam}`;

                let repeatIndex = 0;

                const cleanCartData = {};

                let hasFreeBrusi = false;

                cart.items.forEach(async (item) => {
                    if (item.properties._repeat_product) {
                        isRepeatCheckout = true;
                        repeatCheckoutUrl += `&products.${repeatIndex}.uuid=${item.properties._repeat_product}`;
                        repeatCheckoutUrl += `&products.${repeatIndex}.quantity=${item.quantity}`;
                        repeatCheckoutUrl += `&products.${repeatIndex}.interval_count=${item.properties._repeat_interval_count}`;
                        repeatCheckoutUrl += `&products.${repeatIndex}.interval_type=${item.properties._repeat_interval_type}`;
                        repeatIndex++;

                        // Check if this is a 60+ stikur variant (free brúsi eligible)
                        const variantTitle = (item.variant_title || '').toLowerCase();
                        if (variantTitle.includes('60 stikur') || variantTitle.includes('90 stikur')) {
                            hasFreeBrusi = true;
                        }
                    }

                    if (cleanCart && item.properties._repeat_product) {
                        // This is needed since the Repeat logic is using different variant ids (i.e combo bundle ids) when
                        // communicating with Shopify. We only remove the subscription products.
                        cleanCartData[item.key] = 0;
                    }
                });

                // Add free glerbrúsi for 60+ stikur subscriptions
                if (isRepeatCheckout && hasFreeBrusi) {
                    repeatCheckoutUrl += `&products.${repeatIndex}.uuid=61a2b90d-4faa-4bb6-82f6-c055b4518124`;
                    repeatCheckoutUrl += `&products.${repeatIndex}.quantity=1`;
                    repeatCheckoutUrl += `&products.${repeatIndex}.interval_count=1`;
                    repeatCheckoutUrl += `&products.${repeatIndex}.interval_type=MONTH`;
                    repeatIndex++;
                }

                if (cleanCart && Object.keys(cleanCartData).length > 0) {
                    updateCart({updates: cleanCartData}).then(() => {
                        resolve({
                            isRepeatCheckout: isRepeatCheckout,
                            repeatCheckoutUrl: repeatCheckoutUrl,
                        });
                    });
                    return;
                }

                resolve({
                    isRepeatCheckout: isRepeatCheckout,
                    repeatCheckoutUrl: repeatCheckoutUrl,
                });
            })
            .catch((error) => {
                reject(error);
            });
    });
}

function toggleRepeatSelector(show) {
    console.log("toggleRepeatSelector", show);
    const repeatSelector = document.querySelector(".repeatSelectorParent");
    console.log("repeatSelector", repeatSelector);
    if (repeatSelector && !show) {
        repeatSelector.classList.add("repeatHidden");
    } else {
        repeatSelector.classList.remove("repeatHidden");
    }
}
